import React from "react";
import { motion } from "motion/react";
import folderIcon from "../../../assets/images/folder-icon.svg";
import styles from "./GradeFolders.module.css";

const containerVariants = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      when: "beforeChildren",
      staggerChildren: 0.08,
      delayChildren: 0.08,
    },
  },
  fadeOut: {
    opacity: 0,
    transition: {
      duration: 0.3,
      ease: "easeOut",
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, scale: 0.6 },
  show: {
    opacity: 1,
    scale: 1,
    transition: {
      type: "spring",
      bounce: 0.45,
      duration: 0.5,
    },
  },
};

const GradeFolders = ({
  grades,
  onGradeClick,
  replayKey,
  isFadingOut = false,
}) => {
  if (!grades || grades.length === 0) {
    return (
      <div className={styles["grade-folders-empty"]}>
        <p>No grades available</p>
      </div>
    );
  }

  return (
    <div className={styles["grade-folders-container"]}>
      <motion.div
        key={replayKey}
        className={styles["grade-folders-grid"]}
        variants={containerVariants}
        initial="hidden"
        animate={isFadingOut ? "fadeOut" : "show"}
        exit="fadeOut"
        style={{ pointerEvents: isFadingOut ? "none" : "auto" }}
      >
        {grades.map((grade) => (
          <motion.div
            key={grade}
            className={styles["grade-folder-item"]}
            variants={itemVariants}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.8 }}
            onClick={(event) => onGradeClick?.(grade, event.currentTarget)}
          >
            <img
              src={folderIcon}
              alt="Folder"
              className={styles["folder-icon"]}
            />
            <p className={styles["grade-folder-label"]}>Grade {grade}</p>
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
};

export default GradeFolders;
